export default __webpack_public_path__ + "static/media/kush-vyas-transformation.858b046d.jpeg";